import React, { createContext, useEffect, useReducer } from 'react';

// third-party
import { Chance } from 'chance';
// import jwtDecode from 'jwt-decode';

// reducer - state management
import { LOGIN, LOGOUT } from 'store/reducers/actions';
import authReducer from 'store/reducers/auth';
// import userDetailsReducer from 'store/reducers/users';
import {store, useSelector } from "../store"
// project import
import {LinearLoaderProgress} from 'components/Loaders';
import axios from 'utils/axios';
// import { KeyedObject } from 'types/root';
import { AuthProps, JWTContextType } from 'types/auth';
import { clearStorageItem, getStorageItem } from 'utils/v4-utils/localStorage';
// import { currentTime, todaysDate } from 'date-fran';
// import { useSelector } from 'react-redux';
const chance = new Chance();

// constant
const initialState: AuthProps = {
  isLoggedIn: false,
  isInitialized: false,
  user: null
};

// ==============================|| JWT CONTEXT & PROVIDER ||============================== //

const JWTContext = createContext<JWTContextType | null>(null);

export const JWTProvider = ({ children }: { children: React.ReactElement }) => {
  const [state, dispatch] = useReducer(authReducer, initialState);
  // const [userDetailsState, dispatchUserdetails] = useReducer(userDetailsReducer, initialState);

  const users = useSelector(store => store.users);
  useEffect(() => {
    const init = async () => {
      try {
        const accessToken = getStorageItem('accessToken');
        const fullname = getStorageItem('fullname');
        console.log("\n\t 1-store: ", store)
        console.log("\n\t 2-accessToken: ", accessToken)
        // const time = currentTime();
        // console.log("\n\t 1-time: ", time);
        // console.log("\n\t 1-getHours: ", todaysDate().getHours());
        if (accessToken && fullname) {
          // console.log("\n\t User: ", users)
          dispatch({
            type: LOGIN,
            payload: {
              isLoggedIn: true,
              user: users,
              token: accessToken
            }
          });
        } else {
          dispatch({
            type: LOGOUT
          });
        }
      } catch (err) {
        console.error(err);
        dispatch({
          type: LOGOUT
        });
      }
    };

    init();
  }, []);

  const login = async (serverResponse:any) => {
    const { accessToken, user, } = serverResponse;
    dispatch({
      type: LOGIN,
      payload: {
        isLoggedIn: true,
        user,
        token: accessToken
      }
    });

  };

  const register = async (username: string, password: string, firstName: string, lastName: string) => {
    // todo: this flow need to be recode as it not verified
    const id = chance.bb_pin();
    const response = await axios.post('/api/account/register', {
      id,
      username,
      password,
      firstName,
      lastName
    });
    let users = response.data;

    if (window.localStorage.getItem('users') !== undefined && window.localStorage.getItem('users') !== null) {
      const localUsers = window.localStorage.getItem('users');
      users = [
        ...JSON.parse(localUsers!),
        {
          id,
          username,
          password,
          name: `${firstName} ${lastName}`
        }
      ];
    }

    window.localStorage.setItem('users', JSON.stringify(users));
  };

  const logout = () => {
    clearStorageItem()
    dispatch({ type: LOGOUT });
  };

  const resetPassword = async (username: string) => {};

  const updateProfile = () => {};

  if (state.isInitialized !== undefined && !state.isInitialized) {
    return <LinearLoaderProgress />;
  }

  return <JWTContext.Provider value={{ ...state, login, logout, register, resetPassword, updateProfile }}>{children}</JWTContext.Provider>;
};

export default JWTContext;
